<template>
  <div>
    <vs-prompt
      :title="isNew ? 'Add group' : 'Update group'"
      @cancel="val = ''"
      @accept="accept"
      @close="close"
      :active.sync="prompt"
      :accept-text="isNew ? 'Add' : 'Update'"
      :is-valid="validForm"
      class=""
    >
      <vs-row>
        <vs-col vs-w="12">
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Name</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <vs-input v-model="name" />
            </div>
          </div>
          <div class="vx-row mb-6">
            <div class="vx-col sm:w-1/5 w-full">
              <span>Color</span>
            </div>
            <div class="vx-col sm:w-4/5 w-full">
              <input
                type="color"
                v-model="color"
                class="w-32 h-32 rounded-lg border border-solid custom-color-picker"
                style="border-color: #eee"
                :style="'--color-picker-color:' + color + '62'"
              />
            </div>
          </div>
        </vs-col>
      </vs-row>
    </vs-prompt>
  </div>
</template>


<script>
import { mapGetters } from "vuex";
export default {
  components: {},
  data() {
    return {
      existingId: null,
      name: "",
      color: "#000",
      prompt: false,
      salesGroupId: null,
    };
  },
  computed: {
    ...mapGetters({
      //   venue: "pos/venues/venue",
    }),
    isNew() {
      return !this.existingId;
    },
    validForm() {
      return this.name && this.name.length > 0;
    },
    isSubGroup() {
      return !!this.salesGroupId;
    },
  },
  methods: {
    show(withExisting = null, withSalesGroupId = null) {
      this.name = "";
      this.color = "#000";
      this.existingId = null;
      this.salesGroupId = null;

      if (withSalesGroupId) {
        this.salesGroupId = withSalesGroupId;
      }

      if (withExisting) {
        this.existingId = this.isSubGroup
          ? withExisting.salesProductSubGroupId.id
          : withExisting.salesProductGroupId.id;
        this.name = withExisting.name;
        this.color = withExisting.color;
      }
      this.prompt = true;
    },
    async accept() {
      //   this.$vs.loading();

      let dto = {
        name: this.name,
        color: this.color,
      };

      if (this.isSubGroup) {
        dto.salesProductGroupId = this.salesGroupId;
        if (this.isNew) {
          dto.salesProductSubGroupId = this.uuidv4();
          this.$store.commit(
            "pos/countrySettings/createSalesProductSubGroup",
            dto
          );
        } else {
          dto.salesProductSubGroupId = this.existingId;
          this.$store.commit(
            "pos/countrySettings/updateSalesProductSubGroup",
            dto
          );
        }
      } else {
        if (this.isNew) {
          dto.salesProductGroupId = this.uuidv4();
          this.$store.commit(
            "pos/countrySettings/createSalesProductGroup",
            dto
          );
        } else {
          dto.salesProductGroupId = this.existingId;
          this.$store.commit(
            "pos/countrySettings/updateSalesProductGroup",
            dto
          );
        }
      }

      //   this.$vs.loading.close();
    },
    uuidv4() {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
          c ^
          (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
      );
    },
    close() {},
  },
};
</script>

<style lang="scss" scoped>
</style>
